import {AuthRepository} from '@domain/model/Auth/AuthRepository';

const IsLoggedIn =
  (authRepository: AuthRepository): (() => Promise<boolean>) =>
  (): Promise<boolean> => {
    return authRepository.isLoggedIn();
  };

export {IsLoggedIn};
